import { render, staticRenderFns } from "./BaseMenuListItem.vue?vue&type=template&id=16f75567&scoped=true"
import script from "./BaseMenuListItem.vue?vue&type=script&lang=js"
export * from "./BaseMenuListItem.vue?vue&type=script&lang=js"
import style0 from "./BaseMenuListItem.vue?vue&type=style&index=0&id=16f75567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f75567",
  null
  
)

export default component.exports